import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Linkedin, FileText, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const portraitUrl = '/images/portrait-footer.png';
  const resumeUrl = 'https://drive.google.com/uc?export=download&id=1tzIfB1Dk5UoNDRtcQMIl1oVuRGJETbFS';
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Image and Intro */}
          <div className="flex items-center space-x-6">
            <img
              src={portraitUrl}
              alt="Pratish Jain"
              className="w-20 h-20 rounded-full object-cover border-4 border-amber-100"
            />
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">Pratish Jain</h3>
              <p className="text-gray-600 text-sm">
                B2B SaaS organic growth specialist focused on turning SEO content into qualified leads.
              </p>
            </div>
          </div>

          {/* Right: Links and Actions */}
          <div className="flex flex-col md:items-end space-y-6">
            {/* Navigation Links */}
            <div className="flex flex-wrap gap-6">
              <button onClick={() => handleNavigation('/')} className="text-gray-600 hover:text-amber-600 transition-colors">
                Home
              </button>
              <button onClick={() => handleNavigation('/about')} className="text-gray-600 hover:text-amber-600 transition-colors">
                About
              </button>
              <button onClick={() => handleNavigation('/portfolio')} className="text-gray-600 hover:text-amber-600 transition-colors">
                Portfolio
              </button>
              <a 
                href="https://medium.com/@thepratishjain" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-amber-600 transition-colors"
              >
                Blog
              </a>
            </div>

            {/* Social Links & Resume */}
            <div className="flex items-center space-x-4">
              <a
                href="https://www.linkedin.com/in/pratishjain/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-amber-600 transition-colors"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="mailto:thepratishjain@gmail.com"
                className="text-gray-600 hover:text-amber-600 transition-colors"
              >
                <Mail size={20} />
              </a>
              <a
                href={resumeUrl}
                download="Pratish_Jain_Resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  variant="outline"
                  size="sm"
                  className="border-amber-600 text-amber-600 hover:bg-amber-600 hover:text-white transition-colors"
                >
                  <FileText size={16} className="mr-2" />
                  Download Resume
                </Button>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="mt-12 pt-6 border-t border-gray-200 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Pratish Jain. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;